module.exports = __webpack_public_path__ + "img/netha.56d38d14.png";